<template>
  <div>
    <b-card-body  v-for="(item, index) in result.packages" :key="index">
      <div v-for="(leg, legIndex) in item.flightInfo.outbound" :key="legIndex + 'fout' + index">
        <span>
          <small class="dep-leg w-50">Data plecare:</small>
          <span class="tripInfo w-50">{{ leg.date }}</span>
        </span>
        <span>
          <small class="dep-leg w-50">Ora plecare:</small>
          <span class="tripInfo w-50">{{ leg.depTime == '00:00' ? 'n/a' : leg.depTime  }}</span>
        </span>
      </div>
      <div  v-for="(legInb, legInbIndex) in item.flightInfo.inbound" :key="legInbIndex + 'finb' + index">
        <span>
          <small class="dep-leg w-50">Data intoarcere:</small>
          <span class="tripInfo w-50">{{ legInb.date }}</span>
        </span>
        <span>
          <small class="dep-leg w-50">Ora intoarcere:</small>
          <span class="tripInfo w-50">{{ legInb.depTime == '00:00' ? 'n/a' : legInb.depTime }}</span>
        </span>
      </div>
    </b-card-body>
  </div>
</template>

<script>
export default {
  name: 'FlightInfo',
  props: ['result'],
  created () {
    this.flightInfo = this.result.packages[0].flightInfo
  }
}
</script>
